import Service, { inject as service } from '@ember/service';
import ApiService from 'cio/services/api';
import DS from 'ember-data';
import { TransactionalMessageChannelType } from 'cio/models/transactional-message';

export default class DeliveryService extends Service {
  @service api!: ApiService;
  @service store!: DS.Store;

  delete(id: string) {
    return this.api.delete(`deliveries/${id}`);
  }

  deliver(id: string, data: Record<string, any> = {}) {
    return this.api.post(`deliveries/${id}/send`, { data });
  }

  retry(id: string, data: Record<string, any> = {}) {
    return this.api.post(`deliveries/${id}/retry`, {
      data: {
        override_message_limit: data.overrideLimit,
      },
    });
  }

  redeliver(id: string, data: Record<string, any> = {}) {
    return this.api.post(`deliveries/${id}/redeliver`, { data });
  }

  async fetchTransactionalDeliveries(messageId: string, type: TransactionalMessageChannelType) {
    let draftedDeliveriesPromise = this.queryTransactionalDeliveries(messageId, type, true);
    let sentDeliveriesPromise = this.queryTransactionalDeliveries(messageId, type, false);

    let [draftedDeliveries, sentDeliveries] = await Promise.all([draftedDeliveriesPromise, sentDeliveriesPromise]);

    return [...draftedDeliveries.toArray(), ...sentDeliveries.toArray()];
  }

  private queryTransactionalDeliveries(messageId: string, type: TransactionalMessageChannelType, drafts = false) {
    return this.store.query('delivery', {
      transactional_message_id: messageId,
      type,
      drafts,
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    delivery: DeliveryService;
  }
}
